import { Controller } from "@hotwired/stimulus"
import { chooseTwo } from "../lib/combinatorics"

export default class extends Controller {
  static targets = ["stage", "slider", "count", "total", "formula"]

  connect() {
    this.render()
  }

  update() {
    this.render()
  }

  render() {
    const count = Number(this.sliderTarget.value)
    const total = chooseTwo(count)
    const centerX = 320
    const centerY = 285
    const length = 235
    const start = Math.PI * 1.12
    const spread = Math.PI * .76

    this.stageTarget.replaceChildren()
    for (let index = 0; index < count; index += 1) {
      const angle = start + spread * index / (count - 1)
      const line = document.createElementNS("http://www.w3.org/2000/svg", "line")
      line.setAttribute("x1", centerX)
      line.setAttribute("y1", centerY)
      line.setAttribute("x2", centerX + Math.cos(angle) * length)
      line.setAttribute("y2", centerY + Math.sin(angle) * length)
      line.setAttribute("stroke", index === 0 || index === count - 1 ? "#0284c7" : "#0f172a")
      line.setAttribute("stroke-width", index === 0 || index === count - 1 ? 5 : 3)
      line.setAttribute("stroke-linecap", "round")
      this.stageTarget.append(line)
    }

    this.countTarget.textContent = count
    this.totalTarget.textContent = total
    this.formulaTarget.textContent = `C(${count}, 2) = ${count} × ${count - 1} ÷ 2 = ${total}`
  }
}
